"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _juyc = _interopRequireWildcard(require("@/api/jhyc/juyc"));
var shop = _juyc;
var _index = _interopRequireDefault(require("./info/index.vue"));
var _index2 = _interopRequireDefault(require("./service/index.vue"));
var _index3 = _interopRequireDefault(require("./verification/index.vue"));
var _add = _interopRequireDefault(require("./add"));
var _importForm = _interopRequireDefault(require("./importForm.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'ShopList',
  components: {
    detailsFrom: _index.default,
    addFrom: _add.default,
    serviceFrom: _index2.default,
    verificationFrom: _index3.default,
    importForm: _importForm.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      fromList: this.$constants.fromList,
      isChecked: false,
      listLoading: false,
      headerNum: [{
        count: '',
        type: '1',
        title: '营业中店铺'
      }, {
        count: '',
        type: '0',
        title: '闭店店铺'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        subAddressCode: '',
        storeName: '',
        isSwitch: '1',
        addressCode: '',
        serviceType: '',
        typeId: ''
      },
      autoUpdate: true,
      timeVal: [],
      merId: 0,
      keyNum: 0,
      isDisabled: false,
      indexKey: 0,
      shopInfo: {},
      keyUrl: '',
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        editData: {}
      }
    };
  },
  mounted: function mounted() {
    this.getHeadNum();
    this.getList(1);
  },
  methods: {
    onchangeIsShow: function onchangeIsShow(data) {
      var _this = this;
      shop.abcStoreByEdit({
        id: data.id,
        signStatus: data.signStatus
      }).then(function (res) {
        _this.getSuccess();
      });
    },
    addStore: function addStore() {
      this.editDialogConfig.visible = true;
      this.editDialogConfig.isCreate = 0;
    },
    editStore: function editStore(data) {
      this.editDialogConfig.visible = true;
      this.editDialogConfig.isCreate = 1;
      this.editDialogConfig.data = data;
    },
    delStore: function delStore(data) {
      var _this2 = this;
      this.$modalSure('关闭当前门店吗').then(function () {
        shop.abcStoreByEdit({
          id: data
        }).then(function (res) {
          _this2.$message.success('闭店成功');
          _this2.getSuccess();
        });
      });
    },
    getSuccess: function getSuccess() {
      this.getList();
      this.getHeadNum();
    },
    resetForm: function resetForm() {
      this.editDialogConfig.visible = false;
      this.addVisible = false;
    },
    //关闭弹出框
    hideEditDialog: function hideEditDialog(type, isCreate) {
      this.editDialogConfig.visible = false;
      this.getList();
      isCreate === 0 && this.$message.success('添加成功');
      isCreate === 1 && this.$message.success('编辑成功');
    },
    /**
     *  获取开启商户数
     */
    getHeadNum: function getHeadNum() {
      var _this3 = this;
      var data = _objectSpread({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      shop.merchantShopHeaderNumApi(data).then(function (res) {
        _this3.headerNum[0]['count'] = res.openNum;
        _this3.headerNum[1]['count'] = res.closeNum;
      }).catch(function (res) {});
    },
    /**
     *  列表
     */
    getList: function getList(num) {
      var _this4 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      shop.merchantShopListApi({
        page: this.tableFrom.page,
        limit: this.tableFrom.limit,
        storeName: this.tableFrom.storeName,
        isSwitch: this.tableFrom.isSwitch,
        serviceType: this.tableFrom.serviceType,
        addressCode: this.tableFrom.addressCode,
        subAddressCode: this.tableFrom.subAddressCode
      }).then(function (res) {
        _this4.tableData.data = res.list;
        _this4.tableData.total = res.total;
        _this4.listLoading = false;
      }).catch(function (res) {
        _this4.listLoading = false;
        _this4.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList(page);
      this.getHeadNum();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
      this.getHeadNum();
    },
    getChange: function getChange() {
      this.getHeadNum();
      this.getList(1);
      this.dialogVisible = false;
    },
    closeModel: function closeModel() {
      this.dialogVisible = false;
    },
    onShopService: function onShopService(data) {
      this.shopInfo = data;
      this.$refs.serviceForm.dialogVisible = true;
      this.$refs.serviceForm.getList(data);
    },
    onWriteOff: function onWriteOff(data) {
      this.shopInfo = data;
      this.$refs.verificationForm.dialogVisible = true;
      this.$refs.verificationForm.getList(data);
    },
    // 详情
    onShopDetails: function onShopDetails(data) {
      this.shopInfo = data;
      this.keyUrl = 'https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:' + data.lat + ',' + data.lng + ';title:' + data.storeName + ';addr: ' + data.address + '&key=SMJBZ-WCHK4-ZPZUA-DSIXI-XDDVQ-XWFX7&referer=myapp';
      this.$refs.shopDetail.dialogVisible = true;
    },
    // 导入
    handleImport: function handleImport() {
      this.$refs.importRef.open();
    }
  }
};